var Dlrt;
(function (Dlrt) {
    class SimpleConfirmationModal extends Dlrt.ModalBase {
        constructor(modal, onConfirm) {
            super(modal);
            this.onConfirm = onConfirm;
            this.find('.js-confirm-button').click(() => this.onConfirm());
        }
    }
    Dlrt.SimpleConfirmationModal = SimpleConfirmationModal;
})(Dlrt || (Dlrt = {}));

//# sourceMappingURL=SimpleConfirmationModal.js.map
